import * as _ from 'lodash';
import { Injectable } from '@angular/core';

export interface Source {
    value: string;
    displayName: string;
}

@Injectable()
export class SourceService {

    private _sources: Source[] = [
        {value: 'synapps', displayName: 'Synapps'},
        {value: 'sage-claranet', displayName: 'Claranet'},
        {value: 'sage-diademys', displayName: 'Diademys'},
        {value: 'sage-morea', displayName: 'Morea'},
        {value: 'sage-cba', displayName: 'CBA'},
        {value: 'sage-runiso', displayName: 'Runiso'},
        {value: 'salesforce', displayName: 'Salesforce'},
    ];

    get sources(): Source[] {
        return this._sources;
    }

    public source(value: string): Source {
        return _.find(this._sources, {value});
    }

    public displayName(value: string): string {
        const source = this.source(value);
        return source ? source.displayName : 'source inconnue';
    }

    public isFromSage(sourceValue: string): boolean {
        return sourceValue.indexOf('sage') !== -1;
    }

}
